import React from "react";
import injectSheet from "react-jss";
import { Helmet } from "react-helmet";
import { NavLink } from "react-router-dom";
import {
  BottomNav,
  ErrorContainer,
  Image,
  InitContainer,
  Lightbox,
  MainContent,
  TopStepper,
} from "../../";

const MainLayout = (props) => {
  const {
    classes,
    currentPath,
    history,
    incomplete,
    initialize,
    location,
    match,
    offerIncomplete,
    resetApp,
    steps,
  } = props;

  return (
    <ErrorContainer resetApp={resetApp}>
      <InitContainer initialize={initialize}>
        <div className={classes.app}>
          <Lightbox />
          <Helmet>
            <meta charSet="utf-8" />
            <title>hauskonfigurator</title>
          </Helmet>
          <header className={`${classes.section} ${classes.topSection}`}>
            <div className={`${classes.headerLinks}`}>
              <NavLink
                className={`${classes.headerLink}`}
                to="https://www.hausconcept.ch/datenschutz/"
                target="_blank"
              >
                Datenschutz
              </NavLink>
              <NavLink
                className={`${classes.headerLink}`}
                to="http://www.hausconcept.ch/content/impressum"
                target="_blank"
              >
                Impressum
              </NavLink>
            </div>
            <div className={`${classes.gridContainer}`}>
              <NavLink className={`${classes.title}`} exact to="/">
                <Image src="images/static/logo.svg" alt="Hauskonfigurator" />
              </NavLink>
              <TopStepper
                className={`${classes.full}`}
                currentPath={currentPath}
                history={history}
                incomplete={incomplete}
                steps={steps}
              />
            </div>
          </header>
          <section className={`${classes.section} ${classes.mainSection}`}>
            <MainContent
              currentPath={currentPath}
              location={location}
              offerIncomplete={offerIncomplete}
              history={history}
              incomplete={incomplete}
              steps={steps}
            />
          </section>
          <footer className={`${classes.section} ${classes.bottomSection}`}>
            <div className={`${classes.gridContainer}`}>
              <BottomNav
                currentPath={currentPath}
                history={history}
                location={location}
                match={match}
                steps={steps}
                incomplete={incomplete}
              />
            </div>
          </footer>
        </div>
      </InitContainer>
    </ErrorContainer>
  );
};

const styles = (theme) => ({
  "@global": {
    body: {
      margin: 0,
      padding: 0,
      fontFamily: "Helvetica, sans-serif",
    },
    "*": {
      boxSizing: "border-box",
      outline: "none",
    },
  },
  app: {
    backgroundColor: theme.colors.main_2,
  },
  section: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    width: "100vw",
  },
  topSection: {
    backgroundColor: theme.colors.main_2,
    position: "fixed",
    top: 0,
    left: 0,
    padding: `0 0 ${theme.sizes.gutter / 2}px 0`,
    boxShadow: theme.shadow.initial,
    zIndex: 100,
    height: `${theme.sizes.header}px`,
    [theme.media.medium]: {
      height: `${theme.sizes.headerLarge}px`,
    },
  },
  mainSection: {
    backgroundColor: theme.colors.secondary_3a,
  },
  bottomSection: {
    backgroundColor: theme.colors.main_2,
    position: "fixed",
    bottom: 0,
    left: 0,
    boxShadow: theme.shadow.initial,
    zIndex: 100,
  },
  gridContainer: {
    position: "relative",
    width: "100vw",
    maxWidth: `${theme.sizes.container}px`,
  },
  title: {
    width: "100%",
    display: "block",
    textDecoration: "none",
    color: theme.colors.main_3,
    padding: `0 ${theme.sizes.gutter / 2}px`,
    "& > div": {
      width: "100%",
      maxWidth: "250px",
      padding: `${theme.sizes.gutter / 2}px 0`,
    },
  },
  full: {
    width: "100%",
  },
  headerLinks: {
    position: "absolute",
    right: 0,
    transform: "translateX(-10%)",
    display: "flex",
    justifyContent: "space-around",
    padding: `${theme.sizes.gutter / 4}px 0`,
  },
  headerLink: {
    padding: `0 ${theme.sizes.gutter / 4}px`,
    color: theme.colors.main_3,
    fontSize: "60%",
    textDecoration: "none",
    transition: [
      {
        property: "color",
        duration: theme.speed.fast,
      },
      {
        property: "font-size",
        duration: theme.speed.fast,
      },
    ],
    "&:hover": {
      color: theme.colors.secondary_3b,
    },
  },
});

export default injectSheet(styles)(MainLayout);



// WEBPACK FOOTER //
// ./src/modules/core/components/mainLayout.jsx